import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderHR, {
  GridSkeleton,
  SkeletonButton,
  SkeletonTable,
  SkeletonText,
} from "../HeaderHR";
import KandidatTable from "./Components/KandidatTable";
import TalentPoolTable from "./Components/TalentPoolTable";
type Props = {};

export default function TalentPoolPage({}: Props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <HeaderHR />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            paddingTop: "12vh",
            width: { sm: `calc(100% - ${240}px)` },
          }}
        >
          {loading ? (
            <GridSkeleton justifyContent="center" alignItems="center">
              <SkeletonText variant="text" />
              <SkeletonTable variant="rectangular" />
              <SkeletonButton variant="rectangular" />
            </GridSkeleton>
          ) : (
            <TalentPoolTable />
          )}
        </Box>
      </Box>
    </>
  );
}
